export const DEFAULT_CONFIG = {
    base_url: "./tinymce",
    branding: false,
    height: 500,
    menubar: "edit insert format tools table help",
    paste_data_images: true,
    convert_urls: false,
    resize: true,
    font_family_formats: "Amazon Ember=Amazon Ember; Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif;\
        Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif;\
        Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Oswald=oswald;\
        Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times;\
        Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings",
    font_size_formats: "8px 12px 14px 16px 18px 24px 30px 36px 48px",
    content_style: `.mce-content-body { font-family:"Amazon Ember"; font-size: 14px; line-height: 1.4; overflow-x: auto; } ` +
        `.perm-content{
            border: 3px solid gray;
            margin: 20px 0px 20px 0px;
        }` +
        `.mce-item-anchor {
            background: none !important;
        }` +
        `.mce-content-body a{
            text-decoration: unset !important;
            color: rgb(5, 99, 193) !important;
        }` +
        // Style fenced code blocks: the premium markdown plugin's CSS previously gave
        // <pre> a shaded box; in open-source mode we provide it here so pasted code
        // blocks keep the boxed, monospace appearance (no syntax colouring — markdown-it
        // does not tokenise code).
        `.mce-content-body pre{
            background: #f4f4f4;
            border: 1px solid #e0e0e0;
            border-radius: 4px;
            padding: 12px;
            overflow: auto;
            font-family: 'Courier New', Courier, monospace;
            font-size: 13px;
            line-height: 1.4;
        }` +
        `.mce-content-body code{
            font-family: 'Courier New', Courier, monospace;
        }` +
        // Style markdown tables: markdown-it emits a plain <table> with no borders, so
        // without this the cells collapse into run-together text. Mirrors the boxed,
        // bordered look the premium plugin produced.
        `.mce-content-body table{
            border-collapse: collapse;
        }` +
        `.mce-content-body table th, .mce-content-body table td{
            border: 1px solid #d0d0d0;
            padding: 6px 10px;
        }` +
        `.mce-content-body table th{
            background: #f4f4f4;
            font-weight: bold;
        }` +
        // Definition lists (markdown-it-deflist): bold terms, indented definitions.
        `.mce-content-body dt{ font-weight: bold; }` +
        `.mce-content-body dd{ margin: 0 0 8px 24px; }`,
    custom_elements: "perm-content",
    extended_valid_elements: "amzn1\.abacus\.team.+,perm-content[role-id],div[*]",
    // Exclude broadcast.amazon.com and QuickSuite domains from default iframe sandboxing
    sandbox_iframes_exclusions: ["broadcast.amazon.com", "quicksight.aws.amazon.com", "us-east-1.quicksight.aws.amazon.com", "us-west-2.quicksight.aws.amazon.com"],
    plugins: [
        "advlist", "autolink", "lists", "link", "image", "charmap", "preview",
        "searchreplace", "visualblocks", "code", "fullscreen",
        "insertdatetime", "media", "table", "help", "wordcount", "emoticons"
    ],
    toolbar_sticky: true,
    block_formats: "Paragraph=p; Header 1=h1; Header 2=h2; Header 3=h3; Header 4=h4; Preformatted=pre",
    toolbar: "undo redo |\
        fontfamily fontsize |\
        bold italic underline strikethrough forecolor |\
        link image media table |\
        align lineheight |\
        numlist bullist indent outdent |\
        emoticons charmap |\
        removeformat",
    table_column_resizing: "resizetable",
    entity_encoding: "raw",
    invalid_elements: "script",
    link_default_target: "_blank",
    promotion: false, // Hide premium upgrade promotion option button
    // Rely on the browser's native spellchecker: keep spellcheck enabled on
    // the editor body, and disable TinyMCE's context menu so a normal
    // right-click surfaces the native suggestions (otherwise TinyMCE
    // intercepts right-click and users would have to Ctrl+right-click).
    browser_spellcheck: true,
    // `false` fully disables TinyMCE's context menu; cast because the
    // tinymce-react wrapper types `init` against the normalized options
    // (contextmenu: string[]) even though raw options/runtime accept false.
    contextmenu: false as unknown as string[],
};
